"use client"

import React from "react"
import { useLocation, Outlet, Link } from "react-router-dom"
import { motion } from "framer-motion"
import Footer from "@/components/start/Footer";
import HeroLaw from "@/components/start/HeroLaw"





const HomeEcommerce = () => {
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false)
    const location = useLocation()

    

    

    const handleConsultaClick = () => {
        const form = document.getElementById("registrationForm")
        if (form) {
            form.scrollIntoView({ behavior: "smooth" })
        }
    }

    return (
        <div className="min-h-screen">
            <HeroLaw
                titulo={"Encuentra el abogado que necesitas"}
                subtitulo="Excelencia legal y profesionalismo a su servicio"
                imagenSrc="https://images.unsplash.com/photo-1505664194779-8beaceb93744?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                imagenAlt="Oficina de abogados moderna"
                botonTexto="Consulta Gratuita"
                onBotonClick={handleConsultaClick}
            />

            <div className=" bg-gray-50">
                {/* Main content */}
                <div className="">
                    <main className="p-4 md:p-8">
                        <div className="max-w-7xl mx-auto">
                            <Outlet />
                        </div>
                    </main>
                </div>
            </div>
            <Footer />  
        </div>
    )
}

export default HomeEcommerce

